import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "table-container"
};
var _hoisted_2 = {
  class: "table-content all"
};
var _hoisted_3 = {
  tabindex: "0",
  translate: "no",
  class: "tiptap ProseMirror"
};
var _hoisted_4 = ["innerHTML"];
import { onMounted } from 'vue';
export default {
  __name: 'eTable',
  props: {
    elementContent: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    element: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  emits: ['loaded'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var disabledEdit = function disabledEdit(html) {
      if (html) {
        return html.replace(/contenteditable="true"/g, 'contenteditable="false"').replace(/selectedCell/g, '');
      }
      return html;
    };
    onMounted(function () {
      emit('loaded', 'eTable');
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        ref: "tableRef",
        class: "tableWrapper",
        innerHTML: disabledEdit(__props.elementContent.html)
      }, null, 8, _hoisted_4)])])]);
    };
  }
};